import { Box, Button, Typography, useMediaQuery } from '@mui/material';

function AdvancedPlatform({ setContactUsOpened }: { setContactUsOpened: (s: boolean) => void }) {
  const isMobile = useMediaQuery('(max-width:800px)');

  return (
    <Box
      id="advances_anchor"
      sx={{
        background: 'linear-gradient(180deg, #FFF 0%, #E4F1FF 100%)',
      }}
    >
      <Box
        sx={{
          maxWidth: '1350px',
          margin: 'auto',
          padding: '0 20px',
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'column',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: isMobile ? 'column-reverse' : 'row',
            width: '100%',
            justifyContent: 'space-between',
            gap: isMobile ? '30px' : '40px',
            margin: isMobile ? '80px 0' : '108px 0',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <img
              style={{
                maxWidth: '545px',
                minWidth: isMobile ? undefined : '390px',
                width: '100%',
                maxHeight: '808px',
              }}
              src="/images/advances_image.webp"
              alt="advances"
            ></img>
          </Box>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: isMobile ? '30px' : '40px',
              justifyContent: 'center',
              maxWidth: '660px',
            }}
          >
            <Typography
              sx={{
                fontSize: isMobile ? '32px' : '56px',
                fontFamily: 'RedHat700',
                color: '#171717',
                lineHeight: 'normal',
              }}
            >
              Advanced B2B Platform for Data and Marketing Optimization
            </Typography>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: isMobile ? '0px' : '10px',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  gap: isMobile ? '15px' : '20px',
                  alignItems: 'center',
                }}
              >
                <img src="/images/advanced_img1.svg" alt="advances"></img>
                <Typography
                  sx={{
                    fontSize: isMobile ? '20px' : '24px',
                    fontFamily: 'RedHat700',
                    color: '#171717',
                  }}
                >
                  Data Management at Scale
                </Typography>
              </Box>
              <Typography
                sx={{
                  fontSize: isMobile ? '16px' : '20px',
                  fontFamily: 'RedHat400',
                  color: '#656769',
                  marginLeft: isMobile ? '63px' : '68px',
                  lineHeight: isMobile ? 'normal' : '30px',
                }}
              >
                Unlock the potential of large-scale user data and AI-powered analytics. Our platform provides real-time
                insights to optimize marketing strategies and boost performance.
              </Typography>
            </Box>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: isMobile ? '0px' : '10px',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  gap: isMobile ? '15px' : '20px',
                  alignItems: 'center',
                }}
              >
                <img src="/images/advanced_img2.svg" alt="advances"></img>
                <Typography
                  sx={{
                    fontSize: isMobile ? '20px' : '24px',
                    fontFamily: 'RedHat700',
                    color: '#171717',
                  }}
                >
                  Advanced Analytics for Decision-Making
                </Typography>
              </Box>
              <Typography
                sx={{
                  fontSize: isMobile ? '16px' : '20px',
                  fontFamily: 'RedHat400',
                  color: '#656769',
                  marginLeft: isMobile ? '63px' : '68px',
                  lineHeight: isMobile ? 'normal' : '30px',
                }}
              >
                With powerful analytics tools, businesses can optimize marketing strategies and make data-driven
                decisions, powered by real-time insights.
              </Typography>
            </Box>

            <Button
              onClick={() => {
                setContactUsOpened(true);
              }}
              variant="contained"
              sx={{
                backgroundColor: '#247BFE',
                borderRadius: '12px',
                padding: isMobile ? '15px 30px' : '20px 40px',
                fontSize: isMobile ? '16px' : '20px',
                fontFamily: 'RedHat800',
                color: '#FFF',
                width: isMobile ? '100%' : 'max-content',
                boxShadow: 'none',
                textTransform: 'initial',
              }}
            >
              Get started
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default AdvancedPlatform;
